// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as MapConfig from "./MapConfig.bs.js";

function getHaversineDistance(p1, p2) {
  var pi = 4 * Math.atan(1);
  var rad = function (x) {
    return x * pi / 180;
  };
  var dLat = rad(p2.lat - p1.lat);
  var dLong = rad(p2.lng - p1.lng);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return 6378137.0 * c;
}

function MapUtils$DropIcon(Props) {
  var label = Props.label;
  return React.createElement("div", {
              className: "pickup_drop_composite drop-icon"
            }, React.createElement("div", {
                  className: "marker"
                }, React.createElement("div", undefined, label)), React.createElement("img", {
                  alt: "drop_marker",
                  src: MapConfig.single_holder_icon
                }));
}

var DropIcon = {
  make: MapUtils$DropIcon
};

function MapUtils$PickUpIcon(Props) {
  var label = Props.label;
  return React.createElement("div", {
              className: "pickup_drop_composite pickup-icon"
            }, React.createElement("div", {
                  className: "marker"
                }, React.createElement("div", undefined, label)), React.createElement("img", {
                  alt: "pickup_marker",
                  src: MapConfig.single_holder_icon
                }));
}

var PickUpIcon = {
  make: MapUtils$PickUpIcon
};

function MapUtils$WayPointIcon(Props) {
  var label = Props.label;
  return React.createElement("div", {
              className: "waypoint_composite waypoint-icon"
            }, React.createElement("div", {
                  className: "waypoint-marker"
                }, React.createElement("div", undefined, String(label + 1 | 0))), React.createElement("img", {
                  alt: "waypoints_marker",
                  src: MapConfig.single_holder_icon
                }));
}

var WayPointIcon = {
  make: MapUtils$WayPointIcon
};

export {
  getHaversineDistance ,
  DropIcon ,
  PickUpIcon ,
  WayPointIcon ,
  
}
/* react Not a pure module */
